import { Component, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { TFMService } from 'app/mock-api/tfm.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-media-center-type01',
  standalone: true,
  imports: [MatIconModule, MatTooltipModule, SlickCarouselModule, DatePipe],
  templateUrl: './media-center-type01.component.html',
  styleUrl: './media-center-type01.component.scss'
})
export class MediaCenterType01Component implements OnInit {

  public view: any = {
  }

  constructor(public _tfmService : TFMService, private route: ActivatedRoute) {

    this._tfmService.getPages().then(res => {
      this.view.pages = res;

      this._tfmService.filterBundles({ id: this.view.id, rateType: 'pps', isActive: true }, false).then(res => {
        this.view.bundle = res.content && res.content.length > 0 ? res.content[0] : null;
        this.view.images = this.view.bundle.imageUrls;

        this.view.headerImage = this.view.images[this._tfmService.getRandom(0, this.view.images.length)];

        this._tfmService.log(this.view);
      });
      this._tfmService.log(res);
    });
  }

  parseMetaData(metaData: string | null): { newsLink?: string } | null {
    try {
        return metaData ? JSON.parse(metaData) : null;
    } catch (error) {
        console.error('Invalid metaData JSON', error);
        return null;
    }
}

  ngOnInit(): void {
    this._tfmService.getSite().then(res => {
      this.view.site = res;

      this.view.site.profile = this._tfmService.getSiteProfile(this.view.site.profileID);
      this._tfmService.log(this.view);

      this._tfmService.getNewsletters(this.view.site.agencyID, this.view.site.siteID).then(res => {
        this.view.newsletters = res;
        console.log('Check newsletters: ', this.view.newsletters);
        console.log(this.view.newsletters.content.images);
        // console.log('Featured Image URL:', this.getFeaturedImage());
      });

    });
  }

}
